import { render, staticRenderFns } from "./additional_info.preview.vue?vue&type=template&id=52b3689c&scoped=true&"
import script from "./additional_info.preview.vue?vue&type=script&lang=js&"
export * from "./additional_info.preview.vue?vue&type=script&lang=js&"
import style0 from "./additional_info.preview.vue?vue&type=style&index=0&id=52b3689c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3689c",
  null
  
)

export default component.exports